// @flow
import React from 'react'
import styled from 'styled-components'
import { Input, Checkbox } from 'antd'
import { fontSize, spacing } from 'frontend_core/dist/styles/variables'
import { mediaMax, mediaMin } from 'frontend_core/dist/styles/media'
import Colors from 'components/styles/colors'
import Button from 'components/atoms/Button'
import Title from 'components/atoms/Title'
import LinkText from 'components/atoms/LinkText'
import Icon from 'components/atoms/Icon'
import Description from 'components/atoms/Description'
import FloatBottom from 'components/molecules/FloatBottom'
import ReputationStar from 'components/molecules/ReputationStar'
import InputContainer from 'components/molecules/InputContainer'
import FormItem from 'components/molecules/FormItem'
import CheckboxList from 'components/molecules/CheckboxList'
import FormSectionTitle from 'components/molecules/FormSectionTitle'
import HeadlineReservation from 'components/molecules/HeadlineReservation'
import SelectCreditCardSection, {
  type PropTypes as SelectCreditCardSectionTypes,
} from 'components/organisms/SelectCreditCardSection'
import MainContentsWithSidebarInbox from 'components/templates/MainContentsWithSidebarInbox'
import BillStatementCurrent, {
  type PropTypes as BillStatementCurrentProps,
} from 'components/molecules/BillStatementCurrent'

const Section = styled.div`
  margin-top: ${spacing.large}px;
`
const TitleDesc = styled.pre`
  margin-top: ${spacing.small_3}px;
  color: ${Colors.gray9};
  font-size: ${fontSize.small_2}px;
  line-height: 1.424;
  white-space: pre-wrap;
`
const H2 = styled.h2`
  font-size: ${fontSize.medium}px;
  font-weight: bold;
  ${mediaMin.phone`
    font-size: ${fontSize.medium_2}px;
  `};
`
const SubSection = styled.div`
  margin-top: ${spacing.small_3}px;
  border-top: 1px solid ${Colors.grayE};
`
const LinkTextWrapper = styled.div`
  margin-top: ${spacing.small_3}px;
`
const SectionSubTitleWrapper = styled.div`
  margin-top: ${spacing.medium_2}px;
`
const SectionSubTitle = styled.p`
  font-size: ${fontSize.small_3}px;
  font-weight: bold;
`
const ItemWrapper = styled.div`
  margin-top: ${spacing.small_3}px;
`
const FormWrapper = styled.div`
  margin-top: ${spacing.medium}px;
`
const CheckboxListWrapper = styled.div`
  margin-top: ${spacing.medium_2}px;
`
const ButtonWrapper = styled.span`
  display: inline-block;
  width: 50%;

  &:first-of-type {
    padding-right: ${spacing.small}px;
  }

  &:nth-of-type(2n) {
    padding-left: ${spacing.small}px;
  }

  ${mediaMin.phone`
    width: auto;
  `};
`
const AttentionWrapper = styled.div`
  margin-top: ${spacing.large}px;
`
const AttentionTitle = styled.p`
  font-size: ${fontSize.medium}px;
`
const AttentionBlock = styled.div`
  margin-top: ${spacing.medium}px;
`
const SectionDesc = styled.p`
  margin-top: ${spacing.small_2}px;
  font-size: ${fontSize.small_2}px;
  color: ${Colors.gray9};
`
const RadioListRecommendedWrapper = styled.div`
  margin-top: ${spacing.medium_3}px;
`
const FormSectionWrapper = styled.div`
  margin-top: ${spacing.medium_3}px;

  :first-of-type {
    margin-top: ${spacing.medium}px;
  }

  ${mediaMin.phone`
    margin-top: ${spacing.large}px;
    :first-child {
      margin-top: ${spacing.large}px;
    }
  `};
`
const ButtonItem = styled.div`
  width: calc((100% - 8px) / 2);
  display: inline-block;

  &:not(:first-child) {
    margin-left: ${spacing.small_2}px;
  }

  ${mediaMin.phone`
    width: 160px;
    font-size: ${fontSize.small_3}px;
  `};
`
const BillStatementSection = styled.div`
  padding-top: ${spacing.large}px;
  border-top: 1px solid ${Colors.grayE};
`

export type PropTypes = {
  sidebarInbox: any,
  isShowContentsSp: boolean,
  selectCreditCardSectionProps: SelectCreditCardSectionTypes,
  billStatementCurrentProps: BillStatementCurrentProps,
  isChangeButtonDisabled: boolean,
  onClickChange: Function,
  onClickBack: Function,
}

export default function ReservationChangePaymentPage(props: PropTypes) {
  return (
    <MainContentsWithSidebarInbox
      isShowContentsSp={props.isShowContentsSp}
      sidebarInbox={props.sidebarInbox}
    >
      <HeadlineReservation
        title={i18n.t('page.dashboard.reservation.changePayment.title')}
        href="#"
        onClick={e => {
          e.preventDefault()
          props.onClickBack()
        }}
        linkText={i18n.t('page.dashboard.reservation.backToMessage')}
      >
        {i18n.t('page.dashboard.reservation.changePayment.desc')}
      </HeadlineReservation>
      <Section>
        <SelectCreditCardSection {...props.selectCreditCardSectionProps} />
      </Section>
      <BillStatementSection>
        <BillStatementCurrent {...props.billStatementCurrentProps} />
      </BillStatementSection>
      <FloatBottom textAlign="right" hasSidebar>
        <ButtonItem>
          <Button
            buttonType="medium"
            colorType="gray"
            tag="button"
            fullWidthSp
            onClick={props.onClickBack}
          >
            {i18n.t('page.shared.cancel')}
          </Button>
        </ButtonItem>
        <ButtonItem>
          <Button
            buttonType="medium"
            colorType="blue"
            tag="button"
            fullWidthSp
            disabled={props.isChangeButtonDisabled}
            onClick={props.onClickChange}
          >
            {i18n.t('page.shared.change')}
          </Button>
        </ButtonItem>
      </FloatBottom>
    </MainContentsWithSidebarInbox>
  )
}



// WEBPACK FOOTER //
// ./src/components/pages/ReservationChangePaymentPage/index.jsx